import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Loader2, Mail } from 'lucide-react';
import { Logo } from '../components/Logo';

export function AuthPage() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If user is already authenticated, redirect to home
  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <Logo size="lg" />
          </div>
          <p className="mt-2 text-sm text-gray-600">
            Secure access to your project configuration
          </p>
        </div>

        <div className="card">
          <div className="card-content">
            <div className="text-center">
              <Mail className="mx-auto h-12 w-12 text-gray-400 mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Check Your Email
              </h3>
              <p className="text-sm text-gray-600 mb-6">
                We've sent you a secure magic link to access your project. 
                Please check your email and click the link to continue.
              </p>
              
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <h4 className="text-sm font-medium text-blue-900 mb-2">
                  What to expect:
                </h4>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• Look for an email from "IMA Onboarding Portal"</li>
                  <li>• Click the "Access Your Setup Portal" button</li>
                  <li>• You'll be automatically signed in to your project</li>
                </ul>
              </div>

              <div className="text-xs text-gray-500">
                <p>If you haven't received the email, please check your spam folder.</p>
                <p className="mt-1">
                  Need help? Contact support at{' '}
                  <a href="mailto:support@idealss.com" className="text-primary-600 hover:text-primary-500">
                    support@idealss.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
